export default __webpack_public_path__ + "static/media/favorite-outline-16px.a719eb39.svg";